import { render, staticRenderFns } from "./SelectDiscountReasons.vue?vue&type=template&id=3002446a"
import script from "./SelectDiscountReasons.vue?vue&type=script&lang=js"
export * from "./SelectDiscountReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports